import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { FaWhatsapp } from 'react-icons/fa';

// Bounce on hover
const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
`;

// Pulse animation
const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.4); }
  70% { box-shadow: 0 0 0 8px rgba(37, 211, 102, 0); }
  100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0); }
`;

const Wrapper = styled.div`
  position: fixed;
  bottom: 100px;
  right: 40px; // Match this value with BackToTop
  z-index: 1000;
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};

  @media (max-width: 768px) {
    right: 20px; // Match with BackToTop
    bottom: 80px;
  }

  @media (max-width: 480px) {
    right: 15px; // Match with BackToTop
    bottom: 70px;
  }
`;


const ChatNowButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #25D366;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  width: 40px;
  height: 40px;
  padding: 0;
  position: relative;
  animation: ${pulse} 2s infinite;
  transition: transform 0.3s ease-in-out;

  &:hover {
    animation: ${bounce} 0.6s;
  }

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
  }

  @media (max-width: 480px) {
    width: 34px;
    height: 34px;
  }
`;

const WhatsAppIcon = styled(FaWhatsapp)`
  font-size: 18px;

  @media (max-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

const Tooltip = styled.div`
  position: absolute;
  right: 50px;
  background: #000;
  color: #fff;
  font-size: 12px;
  padding: 5px 8px;
  border-radius: 4px;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;

  ${ChatNowButton}:hover & {
    opacity: 1;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const ChatNow = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

const handleChatClick = () => {
  const message = "Hello, I would like to know more about LK Education’s Courses.";
  const encodedMessage = encodeURIComponent(message); // to avoid spaces/quotes breaking URL
  window.open(`https://wa.me/979488687563?text=${encodedMessage}`, "_blank");
};

  return (
    <Wrapper isVisible={isVisible}>
      <ChatNowButton onClick={handleChatClick} aria-label="Chat on WhatsApp">
        <Tooltip>Chat with us</Tooltip>
        <WhatsAppIcon />
      </ChatNowButton>
    </Wrapper>
  );
};

export default ChatNow;
